import { useEffect, useState } from 'react';
import { loadingFormListMsg, t } from '../../../common/i18n/index.js';
import { useOpenFormAsync } from '../OpenFormProvider.js';

export const useOpenFormList = () => {
  const [ready, setReady] = useState(false);
  const async = useOpenFormAsync();

  useEffect(() => {
    const { controller } = async.fetch
      .getOpenFormListResponse()
      .resolved(([listResponse, draft]) => {
        if (!draft) {
          async.flags.delete('draft') && async.draft.clear();
        } else if (Array.isArray(draft)) {
          async.draft.clear();
          draft.forEach(item => async.draft.set(item.referenceNumber, item));
        }
        async.forms.clear();
        listResponse.forms.forEach(form => async.forms.set(form.id, form));
        async.zeroReasonCodes.clear();
        Object.entries(listResponse.zeroBalanceReasons).forEach(([code, description]) =>
          async.zeroReasonCodes.set(code, description)
        );
        async.zeroPriceUrls.elisaIntranetUrl = listResponse.zeroPriceElisaIntranetUrl ?? '';
        async.zeroPriceUrls.sfKnowledgeArticleUrl = listResponse.zeroPriceSFKnowledgeArticleUrl ?? '';
      })
      .rejected(text => async.actions.notification({ text, type: 'error' }))
      .settled(() => setReady(true))
      .execute({ disable: true, message: t.ZN5B(loadingFormListMsg) });

    return () => {
      controller.abort();
      async.cache.clear();
    };
  }, [async]);

  return ready;
};
